import { useMutation, useQuery } from "@apollo/client";
import {
  APPROVE_SUBMISSION_DOCUMENT_REVIEW_MUTATION,
  BULK_DELETE_SUBMISSIONS_MUTATION,
  CREATE_SUBMISSION_MUTATION,
  DELETE_SUBMISSION_MUTATION,
  FORCE_COMPLETE_SUBMISSION_MUTATION,
  GET_SUBMISSION_QUERY,
  MOVE_TO_REVIEW_MUTATION,
  REJECT_SUBMISSION_DOCUMENT_REVIEW_MUTATION,
  SUBMISSION_VIRTUAL_EVENTS_QUERY,
  UPDATE_SIGNATURE_STATUS_TO_SENT_MUTATION,
  UPDATE_SUBMISSION_MUTATION,
  UPDATE_SUBMISSION_STATUS_MUTATION,
} from "queries/submissions";

export function useCreateSubmission() {
  return useMutation(CREATE_SUBMISSION_MUTATION, {
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useUpdateSubmission() {
  return useMutation(UPDATE_SUBMISSION_MUTATION, {
    update(cache) {
      // Evict submissionVirtualEvents from cache to force fresh network request
      // This ensures the datagrid shows the updated submission title
      cache.evict({ fieldName: "submissionVirtualEvents" });
      cache.gc(); // Garbage collect to clean up orphaned references
    },
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useMoveToReview() {
  return useMutation(MOVE_TO_REVIEW_MUTATION, {
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useApproveSubmissionDocumentReview() {
  return useMutation(APPROVE_SUBMISSION_DOCUMENT_REVIEW_MUTATION, {
    refetchQueries: [GET_SUBMISSION_QUERY, SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useRejectSubmissionDocumentReview() {
  return useMutation(REJECT_SUBMISSION_DOCUMENT_REVIEW_MUTATION, {
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useDeleteSubmission() {
  return useMutation(DELETE_SUBMISSION_MUTATION, {
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useBulkDeleteSubmissions() {
  return useMutation(BULK_DELETE_SUBMISSIONS_MUTATION, {
    refetchQueries: [SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useGetSubmission(id: string, skip?: boolean) {
  return useQuery(GET_SUBMISSION_QUERY, {
    variables: { id },
    skip: skip || !id,
    fetchPolicy: "cache-and-network",
  });
}

export function useUpdateSubmissionStatus() {
  return useMutation(UPDATE_SUBMISSION_STATUS_MUTATION, {
    refetchQueries: [GET_SUBMISSION_QUERY, SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useForceCompleteSubmission() {
  return useMutation(FORCE_COMPLETE_SUBMISSION_MUTATION, {
    refetchQueries: [GET_SUBMISSION_QUERY, SUBMISSION_VIRTUAL_EVENTS_QUERY],
    awaitRefetchQueries: true,
  });
}

export function useUpdateSignatureStatusToSent() {
  return useMutation(UPDATE_SIGNATURE_STATUS_TO_SENT_MUTATION);
}
